module.exports = __webpack_public_path__ + "img/paper.712666d5.svg";